<div>
  <mic-breadcrumb id="customer-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/customers" label="{{ translationService.translate('customersText') }}"></mic-breadcrumb-link>
    <mic-breadcrumb-link label="{{ translationService.translate('customerSetupText') }}"></mic-breadcrumb-link>
  </mic-breadcrumb>

  @if (loading || referentialLoading) {
  <mic-spinner ariaLabel="In Progress" color="accent" [strokeWidth]="5"></mic-spinner>
  } @if (!loading && !referentialLoading) {
  <form [formGroup]="customerFormGroup" (ngSubmit)="saveChanges()">
    <h2 class="page-title" id="customer-heading">{{ translationService.translate('customerSetupText') }}</h2>
    <div class="w-full flex flex-row items-center justify-between">
      <p id="customer-name">
        <b
          ><span class="customer-label">{{ translationService.translate('codeText') }}: </span>
          <span class="customer-value">{{ customer?.customerInfo.code }} | </span
          ><span class="customer-label">{{ translationService.translate('nameText') }}: </span>
          <span class="customer-value">{{ customer?.customerInfo.customerName }}</span></b
        >
      </p>

      <div class="modal-action-row">
        <span [matTooltip]="getSaveButtonTooltip()">
          <button
            id="save-button"
            type="submit"
            mat-flat-button
            color="primary"
            class="mic-btn-icon-left"
            [loading]="isSaving"
            [disabled]="isSaveButtonDisabled()"
          >
            <mat-icon>save</mat-icon><span>{{ translationService.translate('saveLinkText') }} </span>
          </button>
        </span>
      </div>
    </div>

    <mat-tab-group id="tabs" mat-stretch-tabs="false">
      <mat-tab id="info-tab" label="{{ translationService.translate('customerInformationText') }}" formGroupName="customerInfo">
        <h3 id="information-heading">{{ translationService.translate('customerInformationText') }}</h3>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('genericInformationText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>

                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="codeField">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerCodeText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="code"
                        matInput
                        type="text"
                        required
                        [formControlName]="'code'"
                        (keydown.enter)="$event.preventDefault()"
                        [readonly]="readOnlyMode"
                        (blur)="checkIfCustomerCodeExists()"
                        maxlength="10"
                      />
                      @if (customerInfoFormGroup.get('code').hasError('required')) {
                      <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
                      } @if (customerInfoFormGroup.get('code').hasError('exists')) {
                      <mat-error>{{ translationService.translate('codeExistsText') }}</mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="nameField">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerNameText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="name"
                        matInput
                        type="text"
                        [formControlName]="'customerName'"
                        [readonly]="readOnlyMode"
                        maxlength="35"
                        required
                      />
                      @if (customerInfoFormGroup.get('customerName').hasError('required')) {
                      <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <span
                      [matTooltip]="
                        this.customerInfoFormGroup.get('customerType').disabled
                          ? translationService.translate('customerTypeTooltipText')
                          : ''
                      "
                    >
                      <mat-form-field class="w-full" id="typeField">
                        <mat-label class="custom-label-error">{{ translationService.translate('typeColumnText') }} </mat-label>
                        <mat-select subscriptSizing="dynamic" id="type" required [formControlName]="'customerType'">
                          <mat-option value="Customer">{{ translationService.translate('customerText') }}</mat-option>
                          <mat-option value="AssociateDealer">{{ translationService.translate('associateDealerText') }} </mat-option>
                          <mat-option value="AssociateCustomer"
                            >{{ translationService.translate('associateDealerCustomerText') }}
                          </mat-option>
                          @if (this.customer?.customerInfo.customerType === 'DefaultCustomer') {
                          <mat-option value="DefaultCustomer">{{ translationService.translate('defaultCustomerText') }} </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </span>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    @if (showAssociateToField) {
                    <app-dropdown-multiple-search
                      class="w-full"
                      id="associatedToField"
                      [editMode]="true"
                      [id]="'customer-associate-dealer-options'"
                      [options]="associateDealerNames"
                      [formGroup]="customerInfoFormGroup"
                      [controlName]="'associatedTo'"
                      [multipleOption]="false"
                      [label]="translationService.translate('associatedToText')"
                    />
                    }
                  </div>

                  <div style="align-items: normal; flex: 0 0 auto; flex-wrap: wrap; margin-left: 2%">
                    @if (showAssociateToField) {
                    <button (click)="inheritSetting()" id="inherit-setting-button" mat-flat-button class="logout" type="button">
                      {{ translationService.translate('inheritSettingsText') }}
                    </button>
                    }
                  </div>
                </div>

                <div style="display: flex; align-items: center">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap">
                    <p id="status-label" class="toggle-label">{{ translationService.translate('activeText') }}</p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle id="status-switch" [formControlName]="'active'" [checked]="customer.customerInfo.active === 'Y'"
                        >Yes
                      </mat-slide-toggle>
                    </ng-container>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%">
                    <p id="btm-label" class="toggle-label">{{ translationService.translate('btmFlagText') }}</p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle id="btm-switch" [formControlName]="'btmFlag'" [checked]="customer.customerInfo.btmFlag === 'Y'"
                        >Yes
                      </mat-slide-toggle>
                    </ng-container>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%">
                    <p id="rfid-label" class="toggle-label">{{ translationService.translate('rfidFlagText') }}</p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle
                        id="rfid-switch"
                        [formControlName]="'rfidCustFlag'"
                        [checked]="customer.customerInfo.rfidCustFlag === 'Y'"
                        >Yes
                      </mat-slide-toggle>
                    </ng-container>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('geographicInformationText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>

                <div style="display: flex; align-items: center; margin-top: 1%" class="{{ viewMode }}">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap">
                    <mat-form-field class="w-full" id="addressField">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerAddress1Text') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="address1"
                        matInput
                        type="text"
                        [formControlName]="'address1'"
                        [readonly]="readOnlyMode"
                        maxlength="35"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="address2Field">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerAddress2Text') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="address2"
                        matInput
                        type="text"
                        [formControlName]="'address2'"
                        [readonly]="readOnlyMode"
                        maxlength="35"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="cityField">
                      <mat-label class="custom-label-error">{{ translationService.translate('cityText') }}</mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="city"
                        matInput
                        type="text"
                        [formControlName]="'city'"
                        [readonly]="readOnlyMode"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div style="display: flex; align-items: center">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="stateField">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerStateProvinceText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="stateProvince"
                        matInput
                        type="text"
                        [formControlName]="'stateProvince'"
                        [readonly]="readOnlyMode"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="postalField">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerPostalCodeText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="postalCode"
                        matInput
                        type="text"
                        [formControlName]="'postalCode'"
                        [readonly]="readOnlyMode"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="countryField">
                      <mat-label class="custom-label-error">{{ translationService.translate('customerCountryText') }} </mat-label>
                      <mat-select subscriptSizing="dynamic" id="country" formControlName="countryCode">
                        @for (option of countryStates; track option.state) {
                        <mat-option id="StateOption" value="{{ option.state }}">{{ option.propertiesKey }} </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('salesAndContactInformationText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="contactField">
                      <mat-label class="custom-label-error">{{ translationService.translate('contactText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="contact"
                        matInput
                        type="text"
                        [formControlName]="'contactName'"
                        [readonly]="readOnlyMode"
                        maxlength="25"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="emailField">
                      <mat-label class="custom-label-error">{{ translationService.translate('emailAddressText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="emailAddress"
                        matInput
                        type="text"
                        [formControlName]="'email'"
                        (keydown.enter)="$event.preventDefault()"
                        maxlength="60"
                      />
                      @if (customerInfoFormGroup.get('email').hasError('email')) {
                      <mat-error>{{ translationService.translate('selectAtleastOneValueErrorText') }}</mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="phoneField">
                      <mat-label class="custom-label-error">{{ translationService.translate('phoneNumberText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="phone"
                        matInput
                        type="text"
                        [formControlName]="'phoneNumber'"
                        [readonly]="readOnlyMode"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="faxField">
                      <mat-label class="custom-label-error">{{ translationService.translate('faxNumberText') }}</mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="fax"
                        matInput
                        type="text"
                        [formControlName]="'faxNumber'"
                        (keydown.enter)="$event.preventDefault()"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div style="display: flex; align-items: center">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <mat-form-field class="w-full" id="salesField">
                      <mat-label class="custom-label-error">{{ translationService.translate('salesIdText') }}</mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="sales"
                        matInput
                        type="text"
                        [formControlName]="'salesId'"
                        (keydown.enter)="$event.preventDefault()"
                        maxlength="10"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="routeField">
                      <mat-label class="custom-label-error">{{ translationService.translate('routeIdText') }}</mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="route"
                        matInput
                        type="text"
                        [formControlName]="'routeId'"
                        (keydown.enter)="$event.preventDefault()"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="enterpriseField">
                      <mat-label class="custom-label-error">{{ translationService.translate('enterpriseIdText') }}</mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="n"
                        matInput
                        type="text"
                        [formControlName]="'enterpriseId'"
                        (keydown.enter)="$event.preventDefault()"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="cnpjField">
                      @if (this.customer?.customerInfo.optCustCode) {
                      <mat-label class="custom-label-error">
                        {{ translationService.translate('cnpjText') }}
                        <span
                          class="info-icon"
                          matTooltip="{{ translationService.translate('cnpjInfoText') }}"
                          [attr.aria-label]="translationService.translate('cnpjInfoText')"
                          >i</span
                        ></mat-label
                      >
                      } @if (!this.customer?.customerInfo.optCustCode) {
                      <mat-label class="custom-label-error">
                        {{ translationService.translate('shipToNumberText') }}
                      </mat-label>
                      }
                      <input
                        subscriptSizing="dynamic"
                        id="cnpj"
                        matInput
                        type="text"
                        [value]="customer?.customerInfo.shipToCode"
                        [formControlName]="'shipToCode'"
                        (keydown.enter)="$event.preventDefault()"
                        maxlength="20"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </mat-tab>

      <mat-tab id="cam-tab" label="{{ translationService.translate('camSpecsText') }}" formGroupName="customerCamSpec">
        <h3 id="customer-asset-heading">{{ translationService.translate('customerAssetText') }}</h3>
        <div style="display: flex; align-items: flex-start" class="my-5">
          <div style="flex: 0 1 auto; flex-wrap: wrap" class="pr-10 w-80">
            <app-dropdown-multiple-search
              id="customer-cam-spec-options"
              [editMode]="true"
              [id]="'customer-cam-spec-options'"
              [options]="camSpecNames"
              [formGroup]="customerCamSpecFormGroup"
              [controlName]="'camSpecName'"
              [multipleOption]="false"
              [label]="translationService.translate('camSpecNameColumnText')"
            />
          </div>

          <div style="flex: 0 1 auto; flex-wrap: nowrap" class="pr-10 flex flex-row">
            <p id="repair-limit-cam" class="pr-5">{{ translationService.translate('repairLimitsHeader') }}</p>
            <mat-radio-group [formControlName]="'repairLimitsCheckApplyWhen'">
              <ul role="radiogroup" aria-labelledby="repair-limits" class="mt-0 radio-group">
                <li role="radio">
                  <mat-radio-button
                    id="lifetime-radio-button"
                    [checked]="this.customer?.customerCamSpec.repairLimitsCheckApplyWhen === 'LIFETIME'"
                    value="LIFETIME"
                  >
                    <p>{{ translationService.translate('lifetimeText') }}</p></mat-radio-button
                  >
                </li>
                <li role="radio">
                  <mat-radio-button
                    id="retread-radio-button"
                    [checked]="this.customer?.customerCamSpec.repairLimitsCheckApplyWhen === 'RETREAD'"
                    value="RETREAD"
                  >
                    <p>{{ translationService.translate('perRetreadText') }}</p></mat-radio-button
                  >
                </li>
              </ul>
            </mat-radio-group>
          </div>

          <div style="flex: 0 1 auto; flex-wrap: wrap" class="pr-8 pt-2">
            <button
              mat-flat-button
              color="primary"
              class="mic-btn-icon-left"
              id="view-cam-button"
              (click)="showViewCamSPecModal()"
              [disabled]="!customer?.customerCamSpec?.camSpecId"
              type="button"
            >
              <mat-icon>visibility</mat-icon>
              <span>{{ translationService.translate('viewCamText') }}</span>
            </button>
          </div>

          <div style="flex: 0 1 auto; flex-wrap: wrap" class="pt-2">
            <button
              mat-flat-button
              color="primary"
              class="mic-btn-icon-left"
              type="button"
              id="export-cam-button"
              (click)="exportCamSpecWithCustomer()"
            >
              <mat-icon>download</mat-icon>
              <span>{{ translationService.translate('exportCamText') }}</span>
            </button>
          </div>
        </div>
        <div style="display: flex; align-items: center">
          <mat-icon>info</mat-icon>
          <span class="pl-3"> {{ translationService.translate('customerCamInfoText') }}</span>
        </div>
      </mat-tab>

      <mat-tab id="settings-tab" label="{{ translationService.translate('settingsText') }}" formGroupName="customerSettings">
        <h3 id="settings-heading">{{ translationService.translate('settingsText') }}</h3>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel [expanded]="true">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('billingPreferenceText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>

                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <app-spec-dropdown
                      id="creditField"
                      [editMode]="true"
                      [id]="'casingCredit'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'casingCreditCode'"
                      [optionsForCustomer]="dropdownOptions['CasingCredit']"
                      [label]="translationService.translate('casingCreditText')"
                    />
                  </div>
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="purchaseField"
                      [editMode]="true"
                      [id]="'casingPurchase'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'casingPurchaseCode'"
                      [optionsForCustomer]="dropdownOptions['CasingPurchase']"
                      [label]="translationService.translate('casingPurchaseText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="billToField">
                      <mat-label class="custom-label-error">{{ translationService.translate('michelinBillToText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="billTo"
                        matInput
                        type="text"
                        maxlength="10"
                        [formControlName]="'michelinBillTo'"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="shipToField">
                      <mat-label class="custom-label-error">{{ translationService.translate('michelinShipToText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="shipTo"
                        matInput
                        type="text"
                        maxlength="10"
                        [formControlName]="'michelinShipTo'"
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('workOrderAndCasingPreferenceText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>

                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <app-spec-dropdown
                      id="preferredTreadField"
                      [editMode]="true"
                      [id]="'preferredTreads'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'preferredTreadCode'"
                      [optionsForCustomer]="dropdownOptions['PreferredTreadSpec']"
                      [label]="translationService.translate('preferredTreadsText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="gradeField"
                      [editMode]="true"
                      [id]="'casingGrade'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'casingGradeCode'"
                      [optionsForCustomer]="dropdownOptions['CasingGradeTable']"
                      [label]="translationService.translate('casingGradeText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="freeRepairField"
                      [editMode]="true"
                      [id]="'freeRepairs'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'freeRepairCode'"
                      [optionsForCustomer]="dropdownOptions['FreeRepairTable']"
                      [label]="translationService.translate('freeRepairsText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <mat-form-field class="w-full" id="turnAroundField">
                      <mat-label class="custom-label-error">{{ translationService.translate('turnaroundTimeText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="time"
                        matInput
                        type="number"
                        max="999"
                        [formControlName]="'turnAroundTime'"
                        (keydown.enter)="$event.preventDefault()"
                      />
                      @if (customerSettingsFormGroup.get('turnAroundTime')?.hasError('required')) {
                      <mat-error id="turnaroundTimeError">
                        {{ translationService.translate('selectAtleastOneValueErrorText') }}
                      </mat-error>
                      }
                    </mat-form-field>
                  </div>
                </div>

                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <app-spec-dropdown
                      id="treadDepthField"
                      [editMode]="true"
                      [id]="'remainingDepth'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'remainingTreadDepth'"
                      [options]="['R', 'Y', 'N']"
                      [label]="translationService.translate('remainingTreadDepthMinandMaxText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="brandField"
                      [editMode]="true"
                      [id]="'brand'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'brand'"
                      [options]="['R', 'Y', 'N']"
                      [label]="translationService.translate('brandText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="rememberBrandField"
                      [editMode]="true"
                      [id]="'remember'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'rememberBrand'"
                      [optionsForCustomer]="dropdownOptions['RememberBrand']"
                      [label]="translationService.translate('rememberBrandText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="rememberNoteField"
                      [editMode]="true"
                      [id]="'rememberNote'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'rememberCasingNote'"
                      [optionsForCustomer]="dropdownOptions['RememberCasingNote']"
                      [label]="translationService.translate('rememberCasingNoteText')"
                    />
                  </div>
                </div>

                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <app-spec-dropdown
                      id="rDotField"
                      [editMode]="true"
                      [id]="'rDot'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'rtDot'"
                      [options]="['R', 'Y', 'N']"
                      [label]="translationService.translate('rtDotLabelText')"
                    />
                  </div>

                  <div
                    style="flex-direction: column; align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%"
                    class="edit-component"
                  >
                    <mat-form-field class="w-full" id="notesField" subscriptSizing="dynamic">
                      <mat-label class="custom-label-error">
                        <mat-icon style="margin-right: 5px; font-size: 20px">description</mat-icon>
                        {{ translationService.translate('notesText') }}
                      </mat-label>
                      <textarea id="notes" matInput micScrollBar type="text" maxlength="250" rows="4" [formControlName]="'note'">
                      </textarea>
                      @if (customerSettingsFormGroup.get('note').hasError('sqlInjection')) {
                      <mat-error> SQL Injection Warning </mat-error>
                      }
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%">
                    <p id="wheel-label" class="toggle-label">{{ translationService.translate('wheelProcessingText') }}</p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle id="wheel-switch" [formControlName]="'wheelProcessing'">
                        {{ translationService.translate('yesText') }}
                      </mat-slide-toggle>
                    </ng-container>
                  </div>

                  <!-- Invisible field so that the three fields line up with the four fields  -->
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%">
                    <mat-form-field class="w-full" style="visibility: hidden" id="invisibleField">
                      <input
                        subscriptSizing="dynamic"
                        id="invisible2"
                        matInput
                        type="text"
                        [value]=""
                        (keydown.enter)="$event.preventDefault()"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('rejectAndScrapPreferencesText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <app-spec-dropdown
                      id="rejectField"
                      [editMode]="true"
                      [id]="'rejects'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'customerRejects'"
                      [options]="['RETURN', 'SCRAP']"
                      [label]="translationService.translate('customerRejectsText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="stockField"
                      [editMode]="true"
                      [id]="'stock'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'stockRejects'"
                      [options]="['RETURN', 'SCRAP']"
                      [label]="translationService.translate('stockRejectsText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="scrapField"
                      [editMode]="true"
                      [id]="'scrap'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'scrapDisposalCharge'"
                      [optionsForCustomer]="dropdownOptions['DisposalCharge']"
                      [label]="translationService.translate('scrapDisposalChargeText')"
                    />
                  </div>
                </div>
                <!-- ...existing code... -->

                <div style="display: flex; align-items: center">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap">
                    <p id="scrapcasing-label" class="toggle-label">{{ translationService.translate('scrapCasingAtPlantText') }}</p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle id="scrapcasing-switch" [formControlName]="'scrapCasingPlant'">
                        {{ translationService.translate('yesText') }}
                      </mat-slide-toggle>
                    </ng-container>
                    @if (customerSettingsFormGroup.get('scrapCasingPlant')?.hasError('required')) {
                    <mat-error id="scrapCasingPlantError">
                      {{ translationService.translate('selectAtleastOneValueErrorText') }}
                    </mat-error>
                    }
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%">
                    <p id="central-label" class="toggle-label">{{ translationService.translate('centralRejectText') }}</p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle id="central-switch" [formControlName]="'centralReject'">
                        {{ translationService.translate('yesText') }}
                      </mat-slide-toggle>
                    </ng-container>
                    @if (customerSettingsFormGroup.get('centralReject')?.hasError('required')) {
                    <mat-error id="centralRejectError">
                      {{ translationService.translate('selectAtleastOneValueErrorText') }}
                    </mat-error>
                    }
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%">
                    <p id="include-label" class="toggle-label">
                      {{ translationService.translate('includeScrapCasingsInCentralRejectText') }}
                    </p>
                    <ng-container style="padding: 5%">
                      <mat-slide-toggle id="include-switch" [formControlName]="'includeScrapCasingRejectCustomer'">
                        {{ translationService.translate('yesText') }}
                      </mat-slide-toggle>
                    </ng-container>
                    @if (customerSettingsFormGroup.get('includeScrapCasingRejectCustomer')?.hasError('required')) {
                    <mat-error id="includeScrapCasingsRejectCustomerError">
                      {{ translationService.translate('selectAtleastOneValueErrorText') }}
                    </mat-error>
                    }
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>

            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('labelManagementText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="edit-component">
                    <app-spec-dropdown
                      id="finishedLabelField"
                      [editMode]="true"
                      [id]="'finishedLabel'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'finishedLabelFormat'"
                      [optionsForCustomer]="finishedLabelOptions"
                      [label]="translationService.translate('finishedLabelText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="rejectLabelField"
                      [editMode]="true"
                      [id]="'rejectLabel'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'rejectReturnLabelFormat'"
                      [optionsForCustomer]="rejectReturnLabelOptions"
                      [label]="translationService.translate('rejectReturnLabelText')"
                    />
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="scrapLabelField"
                      [editMode]="true"
                      [id]="'scrapLabel'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'rejectScrapLabelFormat'"
                      [optionsForCustomer]="rejectScrapLabelOptions"
                      [label]="translationService.translate('rejectScrapLabelText')"
                    />
                  </div>

                  @if (this.customer?.customerInfo.printBarcodeEnable) {
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="edit-component">
                    <app-spec-dropdown
                      id="barcodeLabelField"
                      [editMode]="true"
                      [id]="'barcodeLabel'"
                      [formGroup]="customerSettingsFormGroup"
                      [controlName]="'barcodeLabelFormat'"
                      [optionsForCustomer]="barcodeOptions"
                      [label]="translationService.translate('barcodeLabelText')"
                    />
                  </div>
                  }
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>

        <div class="flex flex-row">
          <div class="flex-auto">
            <mat-accordion>
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mic-icon class="mr-2" icon="folder"></mic-icon>
                    {{ translationService.translate('posSettingsText') }}
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <mat-divider></mat-divider>
                <div style="display: flex; align-items: center; margin-top: 1%">
                  <div style="align-items: normal; flex: 1; flex-wrap: wrap" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="interfaceId1Field">
                      <mat-label class="custom-label-error"> {{ translationService.translate('interfaceID1LabelText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="id1"
                        matInput
                        type="text"
                        [formControlName]="'interfaceID1'"
                        [readonly]="readOnlyMode"
                      />
                    </mat-form-field>
                  </div>

                  <div style="align-items: normal; flex: 1; flex-wrap: wrap; margin-left: 5%" class="{{ viewMode }}">
                    <mat-form-field class="w-full" id="interfaceId2Field">
                      <mat-label class="custom-label-error"> {{ translationService.translate('interfaceID2LabelText') }} </mat-label>
                      <input
                        subscriptSizing="dynamic"
                        id="id2"
                        matInput
                        type="text"
                        [formControlName]="'interfaceID2'"
                        [readonly]="readOnlyMode"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </mat-expansion-panel>
            </mat-accordion>
          </div>
        </div>
      </mat-tab>

      @if (customer.customerInfo.customerType === 'AssociateDealer') {
      <mat-tab id="associated-dealer-tab" label="{{ translationService.translate('associateDealerCustomersText') }}">
        <h3 id="associate-dealer-heading">{{ translationService.translate('associateDealerCustomersText') }}</h3>
        <div id="associate-customer-table" class="cam-table mt-2">
          <div class="table-wrapper">
            <mic-table class="table-stripped" [config]="tableConfig" [fetcher]="associateCustomerTableFetcher">
              <ng-container *micTableNoData>
                <mic-empty-state icon="layers_clear" title="{{ translationService.translate('emptyTableText') }}"> </mic-empty-state>
              </ng-container>
              <ng-container *micCellTemplate="let item; name: 'activeCell'">
                <div class="flex flex-row gap-2">
                  @if (item.active === 'Y') {
                  <mic-status class="valid">{{ translationService.translate('activeText') }}</mic-status>
                  } @if (item.active === 'N') {
                  <mic-status>{{ translationService.translate('inactiveText') }}</mic-status>
                  }
                </div>
              </ng-container>

              <ng-container *micTableColumnSelector>
                <button mat-flat-button><mat-icon>view_column</mat-icon> Columns</button>
              </ng-container>
            </mic-table>
          </div>
        </div>
      </mat-tab>
      }
    </mat-tab-group>
  </form>
  }

  <ng-template #confirmation>
    <div>{{ this.translationService.translate('redirectCamPopupText').split('%')[0] }}</div>
    <div>{{ this.translationService.translate('redirectCamPopupText').split('%')[1] }}</div>
  </ng-template>
  <mic-modal id="view-cam-modal" class="modalC" #viewCamModal (result)="onViewCamModalClosed($event)"></mic-modal>

  <ng-template #unsavedConfirmation>{{ this.translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal class="modalC" #unsavedChangesModal></mic-modal>
</div>
